import * as COMP from './images';

const Serie = [
  { id:12,
    name: 'The Witcher',
    image: COMP.thewicher,
    sinopse: 'O mutante Geralt de Rívia é um caçador de monstros que luta para encontrar seu lugar num mundo onde as pessoas muitas vezes são mais perversas que as criaturas selvagens.',
    trailer: 'https://youtu.be/tjujvMkqWe4',
    imageCapa: COMP.thewitchercapa,
  },
  { id:13,
    name: 'La Casa de Papel',
    image: COMP.lacasadepapel,
    sinopse: 'Um homem misterioso que atende pelo nome de El Profesor, está planejando o maior assalto do século. A fim de realizar o ambicioso plano ele recruta uma gangue de oito pessoas com certas habilidades que não tem nada a perder. O objetivo é infiltrar na Casa da Moeda, de modo que eles possam imprimir 2,4 bilhões de euros. Para fazer isso eles precisam de onze dias de reclusão, durante o qual eles vão ter que lidar com sessenta e sete reféns e as forças da Polícia de Elite, com cenas de muita ação e planos brilhantes de El Profesor.',
    trailer: 'https://www.youtube.com/watch?v=fgS9vZJGcQQ',
    imageCapa: COMP.lacasadepapelcapa,
  },
  { id:14,
    name: 'Emily em Paris',
    image: COMP.emilyemparis,
    sinopse: 'Emily Cooper consegue o trabalho dos sonhos em Paris. Agora, ela precisa administrar a carreira, os amigos e o amor na Cidade Luz.',
    trailer: 'https://youtu.be/d1sP0QTYWUo',
    imageCapa: COMP.emilyempariscapa,
  },
  { id:15,
    name: 'Stranger Things',
    image: COMP.strangerthings,
    sinopse: 'Quando um garoto desaparece, a cidade toda participa nas buscas. Mas o que encontram são segredos, forças sobrenaturais e uma menina.',
    trailer: 'https://youtu.be/Yih1taiXm3Y',
    imageCapa: COMP.strangerthingscapa,
  },
  { id:16,
    name: 'The Rain',
    image: COMP.therain,
    sinopse: 'Seis anos após um vírus exterminar quase toda a população da Escandinávia, dois irmãos e um grupo de jovens sobreviventes partem em busca de segurança e de respostas.',
    trailer: 'https://youtu.be/Se3AfHO7GmY',
    imageCapa: COMP.theraincapa,
  },
  { id:17,
    name: 'Round 6',
    image: COMP.round6,
    sinopse: 'Centenas de jogadores falidos aceitam um estranho convite para um jogo de sobrevivência. Um prêmio milionário aguarda, mas as apostas são altas e mortais.',
    trailer: 'https://youtu.be/1bXuJn77Cfc',
    imageCapa: COMP.round6capa,
  },
  { id:18,
    name: 'Mãe Só Tem Duas',
    image: COMP.maesotemduas,
    sinopse: 'Depois de descobrirem que seus bebês foram trocados na maternidade, duas mulheres acham uma saída inusitada: formar uma família.',
    trailer: 'https://www.youtube.com/watch?v=MonLgXmHd3U',
    imageCapa: COMP.maesotemduascapa,
  },
  { id:19,
    name: 'Elite',
    image: COMP.elite,
    sinopse: 'Após três jovens da escola pública serem transferidos para um conceituado colégio de elite, o conflito entre classes acaba levando a um assassinato.',
    trailer: 'https://youtu.be/Oqv81BdRs7w',
    imageCapa: COMP.elitecapa,
  },
  { id:20,
    name: 'Marvel - Demolidor',
    image: COMP.demolidor,
    sinopse: 'Cego desde pequeno, Matt Murdock luta contra a injustiça durante o dia como advogado e à noite nas ruas de Hell’s Kitchen, Nova York.',
    trailer: 'https://youtu.be/y3GkQ6yoAA4',
    imageCapa: COMP.demolidorcapa,
  },
  { id:21,
    name: 'Maid',
    image: COMP.maid,
    sinopse: 'Após sair de um relacionamento abusivo, uma jovem mãe começa a trabalhar fazendo faxina para sustentar a filha e construir um futuro melhor para elas.',
    trailer: 'https://youtu.be/M4nrGje_pyc',
    imageCapa: COMP.maidcapa,
  },
  { id:22,
    name: 'Outra Vida',
    image: COMP.outravida,
    sinopse: 'Um enorme artefato alienígena pousa na Terra, e Niko Breckinridge tem de liderar uma missão interestelar para rastrear sua origem e fazer contato com os extraterrestres.',
    trailer: 'https://www.youtube.com/watch?v=inT2pAVfXnA',
    imageCapa: COMP.outravidacapa,
  },
  { id:23,
    name: 'Lupin',
    image: COMP.lupin,
    sinopse: 'Na adolescência, a vida de Assane Diop dá uma guinada radical quando seu pai morre após ser acusado de um crime que não cometeu. Vinte e cinco anos depois, Assane se inspira em "Arsène Lupin, o Ladrão de Casaca" para vingá-lo.',
    trailer: 'https://youtu.be/FoiQ-Xr8NDI',
    imageCapa: COMP.lupincapa,
  },
  { id:24,
    name: 'Sweet Tooth',
    image: COMP.sweet,
    sinopse: 'Em uma perigosa aventura em um mundo pós-apocalíptico, um adorável menino-cervo sai em busca de um novo começo na companhia de um protetor rabugento.',
    trailer: 'https://youtu.be/0mz_ImwSOpM',
    imageCapa: COMP.sweetcapa,
  },
  { id:25,
    name: 'Fate: A Saga Winx',
    image: COMP.winx,
    sinopse: 'Decididas a controlar seus poderes mágicos, cinco adolescentes encaram rivalidades, romances e estudos do mundo sobrenatural em uma escola para fadas.',
    trailer: 'https://youtu.be/FmyB6V4XgMk',
    imageCapa: COMP.winxcapa,
  },
  { id:26,
    name: 'Bridgerton',
    image: COMP.bridgerton,
    sinopse: 'Oito irmãos inseparáveis buscam amor e felicidade na alta sociedade de Londres.',
    trailer: 'https://youtu.be/pyi8QAlHR8k',
    imageCapa: COMP.bridgertoncapa,
  },
  { id:27,
    name: 'You',
    image: COMP.you,
    sinopse: 'Obcecado por uma aspirante a escritora, um charmoso gerente de livraria lança mão de medidas extremas para entrar na vida dela.',
    trailer: 'https://youtu.be/WoV4O0Jfm8U',
    imageCapa: COMP.youcapa,
  },
  { id:28,
    name: 'Peaky Blinders: Sangue, Apostas e Navalhas',
    image: COMP.peakb,
    sinopse: 'Thomas Shelby e seus irmãos retornam a Birmingham depois de servir no exército britânico durante a Primeira Guerra Mundial. Os Peaky Blinders, a gangue na qual Thomas é líder, controlam a cidade de Birmingham. Mas, como as ambições de Shelby se estendem para além de Birmingham, ele planeja construir o império de negócios que criou e impedir qualquer um que atrapalhar.',
    trailer: 'https://www.adorocinema.com/series/serie-11303/video-19564340/',
    imageCapa: COMP.peakbcapa,
  },
  { id:29,
    name: 'Arcane',
    image: COMP.arcane,
    sinopse: 'Em meio ao conflito entre as cidades-gêmeas de Piltover e Zaun, duas irmãs lutam em lados opostos de uma guerra entre tecnologias mágicas e convicções incompatíveis.',
    trailer: 'https://youtu.be/3MB3OK3Xnvs',
    imageCapa: COMP.arcanecapa,
  },
  { id:30,
    name: 'Riverdale',
    image: COMP.riverdale,
    sinopse: 'Enquanto tentam lidar com problemas típicos da adolescência como amor, sexo, escola e família, Archie e sua turma se envolvem em um grande mistério.',
    trailer: 'https://www.youtube.com/watch?v=HxtLlByaYTc',
    imageCapa: COMP.riverdalecapa,
  },
  { id:31,
    name: 'Vikings',
    image: COMP.vikins,
    sinopse: 'Ragnar Lothbrok, um jovem que se considera descendente de Odin, é um guerreiro, fazendeiro e chefe de família. Visionário e sonhando viver diversas aventuras, ele acredita que as riquezas sonhadas por seu povo encontram-se além do mar Báltico. Mas para conseguir conquistá-las ele precisa convencer Earl Haraldson, o líder de seu povo, a permitir que ele e seus guerreiros viagem em direção à Inglaterra.',
    trailer: 'https://youtu.be/saaFe2zZYbo',
    imageCapa: COMP.vikinscapa,
  },
  { id:32,
    name: 'Anne With an "E',
    image: COMP.anne,
    sinopse: 'O mundo de Green Gables que Anne tanto adora se expande com novas pessoas e emocionantes histórias de amor, perdas e amadurecimento.',
    trailer: 'https://youtu.be/bBervTlBurY',
    imageCapa: COMP.annecapa,
  },
];

export default Serie;